import Image from 'next/image';
import { SetStateAction, useEffect } from 'react';
import styled from 'styled-components';

import dayjs from 'dayjs';
import advanceFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advanceFormat);
import Calendar from 'react-calendar';

import { useMediaQuery } from '../../layouts/Navbar/NavBar';
import { MyErrorObject } from './Header';

const CalendarStyle = styled(Calendar)`
  width: 100%;
  border-radius: 10px;
  background-color: #eeeeee;

  .react-calendar__tile.future-date {
    color: grey;
    font-weight: thin;
  }

  .react-calendar__navigation {
    text-align: center;

    button {
      min-width: 40px;
      font-weight: 400;
      color: black;
    }

    button[disabled] {
      color: grey;
      font-weight: 300;
    }
    margin-bottom: 8px;
  }

  .react-calendar__navigation__label {
    @media (max-width: 460px) {
      font-size: 13px;
    }
  }

  .react-calendar__month-view__weekdays {
    text-align: center;
    margin-bottom: 6px;
    abbr {
      text-decoration: none;
    }
  }

  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    row-gap: 6px;
    padding-bottom: 8px;
  }

  @media (max-width: 570px) {
    .react-calendar__month-view__weekdays__weekday {
      font-size: 9px;
    }

    button {
      font-size: 12px;
    }
  }
`;

interface IProps {
  selectedDate: any;
  setSelectedDate: React.Dispatch<SetStateAction<any>>;
  dispCalendar: boolean;
  setDispCalendar: React.Dispatch<SetStateAction<boolean>>;
  setCityDropdownToggle: React.Dispatch<SetStateAction<boolean>>;
  cityDropdownToggle: boolean;
  tourDropdownToggle: boolean;
  setTourDropdownToggle: React.Dispatch<SetStateAction<boolean>>;
  submitReview: Record<string, unknown>;
  setSubmitReview: React.Dispatch<SetStateAction<Record<string, unknown>>>;
  errorStates: Record<string, boolean>;
  setErrorStates: React.Dispatch<SetStateAction<Record<string, boolean>>>;
  errorObject: MyErrorObject;
  setErrorObject: React.Dispatch<SetStateAction<MyErrorObject>>;
}

const DateSelect = ({
  selectedDate,
  setSelectedDate,
  dispCalendar,
  setDispCalendar,
  cityDropdownToggle,
  setCityDropdownToggle,
  tourDropdownToggle,
  setTourDropdownToggle,
  submitReview,
  setSubmitReview,
  errorStates,
  setErrorStates,
  errorObject,
  setErrorObject
}: IProps) => {
  const mediaQuery = useMediaQuery(768);
  useEffect(() => {
    setDispCalendar(false);
    if (selectedDate) {
      setSubmitReview(prevstate => {
        return {
          ...prevstate,
          date: selectedDate
        };
      });
    }
  }, [selectedDate]);
  const handleCalendarChange = (date: any) => {
    setSelectedDate(date);
    if (errorObject.date) {
      const obj = { ...errorObject };
      delete obj.date;
      // delete obj.cities;
      setErrorObject(obj);
    }
  };
  return (
    <div
      className="w-[100%] relative bg-[#EEEEEE] flex justify-between items-center sm:px-3 py-3 rounded-[5px] lg:rounded-[10px] mt-3 hover:cursor-pointer"
      onClick={e => {
        e.stopPropagation();
        setCityDropdownToggle(false);
        setTourDropdownToggle(false);
        setDispCalendar(!dispCalendar);
      }}
    >
      <div className="flex justify-center items-center ">
        <span className="px-3">
          <Image
            src={
              'https://res.cloudinary.com/see-sight-tours/image/upload/v1685533909/Remaining%20images/Reviews/calendar_iew39q.svg'
            }
            width={mediaQuery ? 16 : 20}
            height={mediaQuery ? 16 : 20}
            alt="calendar image"
          />
        </span>
        <span className="text-[14px]  xl:text-[16px] font-[500] text-[#333333]">
          {selectedDate
            ? dayjs(selectedDate).format('MMMM Do YYYY')
            : 'When Did You Go?'}
        </span>
      </div>
      <div className="px-3">
        <Image
          src={
            'https://res.cloudinary.com/see-sight-tours/image/upload/v1686742410/Remaining%20images/Reviews/review-filtercitydropdown_mtjjfv.svg'
          }
          width={15}
          height={15}
          alt="dropdown"
        />
      </div>
      {dispCalendar && (
        <div
          onClick={(e: any) => {
            e.stopPropagation();
          }}
          className="absolute top-[100%] left-0 w-[100%] z-50"
        >
          <CalendarStyle
            value={selectedDate || new Date()}
            onClickDay={value => handleCalendarChange(value)}
            maxDate={new Date()}
            tileClassName={({ date, view }) => {
              if (view === 'month' && dayjs(date).isAfter(dayjs(), 'day')) {
                return 'future-date';
              }
              return '';
            }}
          />
        </div>
      )}
    </div>
  );
};

export default DateSelect;
